import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import * as t from '@/types'
import steps from '@/steps'
import { Dictionary } from 'vue-router/types/router'


const COOKIE_NAME = 'session-id'

Vue.use(Vuex)

const data: t.APIData = {
  email: '',
  settingSave: '',
  settingCompare: '',
  settingConsent: 'false',
  settingFinanceAreas: '',
  stepReached: '0',

  // step 1
  Net_Income_1_Amt: '',
  Net_Income_1_Frequency: t.Frequency.monthly,

  Net_Income_2_Amt: '',
  Net_Income_2_Frequency: t.Frequency.monthly,

  Child_Benefit_Amt: '',
  Child_Benefit_Frequency: t.Frequency.monthly,

  Inc_Other_1_Amt: '',
  Inc_Other_1_Frequency: t.Frequency.monthly,

  Inc_Other_2_Amt: '',
  Inc_Other_2_Frequency: t.Frequency.monthly,


  // step 2
  Rent_Mortgage_Amt: '',
  Rent_Mortgage_Freq: t.Frequency.monthly,

  Utilities_Amt: '',
  Utilities_Freq: t.Frequency.monthly,

  TV_Broadband_Amt: '',
  TV_Broadband_Freq: t.Frequency.monthly,

  TV_Licence_Amt: '',
  TV_Licence_Freq: t.Frequency.monthly,

  Family_Pet_Amt: '',
  Family_Pet_Freq: t.Frequency.monthly,

  House_Purchases_Amt: '',
  House_Purchases_Freq: t.Frequency.monthly,


  // step 3
  Childcare_Amt: '',
  Childcare_Freq: t.Frequency.monthly,

  Groceries_Amt: '',
  Groceries_Freq: t.Frequency.monthly,

  Entertainment_Amt: '',
  Entertainment_Freq: t.Frequency.monthly,

  Petrol_Diesel_Amt: '',
  Petrol_Diesel_Freq: t.Frequency.monthly,

  Public_Transport_Amt: '',
  Public_Transport_Freq: t.Frequency.monthly,


  // step 4
  Mobile_Phone_Amt: '',
  Mobile_Phone_Freq: t.Frequency.monthly,

  Personal_Care_Amt: '',
  Personal_Care_Freq: t.Frequency.monthly,

  Club_membership_Amt: '',
  Club_membership_Freq: t.Frequency.monthly,

  Clothing_Amt: '',
  Clothing_Freq: t.Frequency.monthly,

  Gifts_Amt: '',
  Gifts_Freq: t.Frequency.monthly,

  Online_Amt: '',
  Online_Freq: t.Frequency.monthly,


  // step 5
  Credit_Card_1_Bal: '',
  Credit_Card_1_Amt: '',
  Credit_Card_1_Freq: t.Frequency.monthly,

  Credit_Card_2_Bal: '',
  Credit_Card_2_Amt: '',
  Credit_Card_2_Freq: t.Frequency.monthly,

  Personal_Loan_1_Bal: '',
  Personal_Loan_1_Amt: '',
  Personal_Loan_1_Freq: t.Frequency.monthly,

  Personal_Loan_2_Bal: '',
  Personal_Loan_2_Amt: '',
  Personal_Loan_2_Freq: t.Frequency.monthly,

  Car_Loan_1_Bal: '',
  Car_Loan_1_Amt: '',
  Car_Loan_1_Freq: t.Frequency.monthly,

  Car_Loan_2_Bal: '',
  Car_Loan_2_Amt: '',
  Car_Loan_2_Freq: t.Frequency.monthly,

  Debt_Other_Bal: '',
  Debt_Other_Amt: '',
  Debts_Other_Freq: t.Frequency.monthly,


  // step 6
  Home_Insurance_Amt: '',
  Home_Insurance_Freq: t.Frequency.monthly,

  Car_Insurance_Amt: '',
  Car_Insurance_Freq: t.Frequency.monthly,

  Health_Insurance_Amt: '',
  Health_Insurance_Freq: t.Frequency.monthly,

  Mortgage_Protection_Amt: '',
  Mortgage_Protection_Freq: t.Frequency.monthly,

  Life_Insurance_Amt: '',
  Life_Insurance_Freq: t.Frequency.monthly,

  Other_Insurances_Amt: '',
  Other_Insurances_Freq: t.Frequency.monthly,


  // step 7
  Emergency_Fund: '',
  Emergency_Fund_Bal: '',
  Emergency_Fund_Amt: '',
  Emergency_Fund_Freq: t.Frequency.monthly,

  Education_Fund: '',
  Education_Fund_Bal: '',
  Education_Fund_Amt: '',
  Education_Fund_Freq: t.Frequency.monthly,

  Annual_Holiday: '',
  Annual_Holiday_Bal: '',
  Annual_Holiday_Amt: '',
  Annual_Holiday_Freq: t.Frequency.monthly,

  Christmas_Fund: '',
  Christmas_Fund_Bal: '',
  Christmas_Fund_Amt: '',
  Christmas_Fund_Freq: t.Frequency.monthly,

  Save_Other_1_Goal: '',
  Save_Other_1_Bal: '',
  Save_Other_1_Amt: '',
  Save_Other_1_Freq: t.Frequency.monthly,

  Save_Other_2_Goal: '',
  Save_Other_2_Bal: '',
  Save_Other_2_Amt: '',
  Save_Other_2_Freq: t.Frequency.monthly,
}

export default new Vuex.Store({
  state: { data },
  mutations: {
    setData (state, newData: Partial<t.APIData>) {
      const oldData = state.data
      for (const [key, value] of Object.entries(newData)) {
        if (oldData.hasOwnProperty(key)) {
          Vue.set(oldData, key, value)
        }
      }
    },
    setStepReached (state, step: number) {
      const maxStep = parseInt(state.data.stepReached, 10)
      step = Math.max(maxStep, step)
      state.data.stepReached = `${step}`
    },
    setEmail (state, email: string) {
      state.data.email = email
    },
    setSettingCompare (state, value: string) {
      state.data.settingCompare = value
    },
    setSettingSave (state, value: string) {
      state.data.settingSave = value
    },
    setSettingConsent (state, value: string) {
      state.data.settingConsent = value
    },
    setSettingFinanceAreas (state, value: string) {
      state.data.settingFinanceAreas = value
    },
  },
  actions: {
    async sendEmail () {
      await axios.post('/?send_email=true')
    },
    async saveData ({ state, getters }) {
      const allData = Object.assign({}, state.data) as Dictionary<any>
      const getterProps = [
        'annualIncome',
        'annualHousehold',
        'annualDay2Day',
        'annualPersonal',
        'annualDebtRepayments',
        'annualProtection',
        'annualSavingsPayments',
        'annualExpenses',
        'annualDifference',
        'monthlyDifference',
        'monthlyIncome',
        'monthlyExpenses',
        'totalDebt',
        'totalSave',
      ]
      for (const key of getterProps) {
        allData[key] = getters[key] || 0
      }
      const jsonData = JSON.stringify(allData)
      await axios.post('/', jsonData)
      /*
      localStorage.setItem('state', jsonData)
      //*/
    },
    async loadData ({ commit }) {
      const result = await axios.get('/')
      const jsonData = result.data
      /*
      jsonData = localStorage.getItem('state')
      jsonData = JSON.parse(jsonData)
      // */
      if (!jsonData) {
        return
      }
      commit('setData', jsonData)
    },
    async setEmail ({ commit, dispatch }, email: string) {
      commit('setEmail', email)
      await dispatch('saveData')
    },
    async setSettingCompare ({ commit, dispatch }, value: string) {
      commit('setSettingCompare', value)
      await dispatch('saveData')
    },
    async setSettingSave ({ commit, dispatch }, value: string) {
      commit('setSettingSave', value)
      await dispatch('saveData')
    },
    async setSettingConsent ({ commit, dispatch }, value: string) {
      commit('setSettingConsent', value)
      await dispatch('saveData')
    },
    async setSettingFinanceAreas ({ commit, dispatch }, value: string) {
      commit('setSettingFinanceAreas', value)
      await dispatch('saveData')
    },
    async toggleFinanceArea ({ state, commit, dispatch }, toggle: string) {
      const areas = new Set()
      const oldValues = (state.data.settingFinanceAreas || '').split(',')
      for (const val of oldValues) {
        if (val === '') {
          continue
        }
        areas.add(val)
      }
      if (areas.has(toggle)) {
        areas.delete(toggle)
      } else {
        areas.add(toggle)
      }
      const value = Array.from(areas).join(',')
      await dispatch('setSettingFinanceAreas', value)
    },
    async resetEverything ({ state }) {
      document.cookie = `${COOKIE_NAME}=; Max-Age=-99999999;`
      window.location.replace('/')
      return true
    },
  },
  getters: {
    email: (state) => state.data.email,
    settingCompare: (state) => state.data.settingCompare,
    settingSave: (state) => state.data.settingSave,
    settingConsent: (state) => state.data.settingConsent,
    settingFinanceAreas: (state) =>  {
      return (state.data.settingFinanceAreas || '').split(',')
    },

    getData: (state) => (key: string) => {
      const allData = state.data
      if (allData.hasOwnProperty(key)) {
        return allData[key]
      }
      return 0
    },

    isStepCompleted: (_, getters) => (step: t.StepDefinition) => {
      return step.index < getters.stepReached
    },

    stepTotal: (_, getters) => (step: t.StepDefinition) => {
      let total = 0.0
      for (const variable of step.variables) {
        let value: string | undefined = '0'
        switch (variable.type) {
          case t.VariableType.triple:
            value = variable.variable3
            break
          case t.VariableType.double:
            value = variable.variable2
            break
          case t.VariableType.single:
          default:
            value = variable.variable
            break
        }
        let multiplier = 12
        switch (getters.getData(variable.frequency)) {
          case t.Frequency.annual:
            multiplier = 1
            break
          case t.Frequency.weekly:
            multiplier = 52
            break
          case t.Frequency.monthly:
            default:
            multiplier = 12
            break
        }

        const valueFloat = parseFloat(getters.getData(value) || '0')
        const valueAnnual = valueFloat * multiplier
        total += valueAnnual
      }
      return parseInt(total.toString(), 10)
    },

    annualIncome: (_, getters) => getters.stepTotal(steps.step1),
    annualHousehold: (_, getters) => getters.stepTotal(steps.step2),
    annualDay2Day: (_, getters) => getters.stepTotal(steps.step3),
    annualPersonal: (_, getters) => getters.stepTotal(steps.step4),
    annualDebtRepayments: (_, getters) => getters.stepTotal(steps.step5),
    annualProtection: (_, getters) => getters.stepTotal(steps.step6),
    annualSavingsPayments: (_, getters) => getters.stepTotal(steps.step7),
    annualExpenses: (_, getters) => {
      return (getters.annualHousehold +
        getters.annualDay2Day +
        getters.annualPersonal +
        getters.annualDebtRepayments +
        getters.annualProtection +
        getters.annualSavingsPayments)
    },
    annualDifference: (_, getters) => {
      return getters.annualIncome - getters.annualExpenses
    },
    monthlyDifference: (_, getters) => {
      return parseInt((getters.annualDifference / 12).toString(), 10)
    },
    monthlyIncome (_, getters) {
      return parseInt((getters.annualIncome / 12).toString(), 10)
    },
    monthlyExpenses (_, getters) {
      return parseInt((getters.annualExpenses / 12).toString(), 10)
    },
    totalDebt: (_, getters) => {
      const variables = [
        'Credit_Card_1_Bal',
        'Credit_Card_2_Bal',
        'Personal_Loan_1_Bal',
        'Personal_Loan_2_Bal',
        'Car_Loan_1_Bal',
        'Car_Loan_2_Bal',
        'Debt_Other_Bal',
      ]

      const total = variables
        .map((v) => parseFloat(getters.getData(v)))
        .reduce((a, b) => a + b)
      return total
    },
    totalSave: (_, getters) => {
      const variables = [
        'Emergency_Fund_Bal',
        'Education_Fund_Bal',
        'Annual_Holiday_Bal',
        'Christmas_Fund_Bal',
        'Save_Other_1_Bal',
      ]

      const total = variables
        .map((v) => parseFloat(getters.getData(v)))
        .reduce((a, b) => a + b)
      return total
    },
    stepReached (_, getters) {
      const value = getters.getData('stepReached')
      if (!value) {
        return 0
      }
      const step = parseInt(value, 10)
      return step
    },
    endReached (_, getters) {
      return getters.stepReached >= 8
    }
  },
  modules: {
  },
})
